export const SERVER_CONFIG = {
  IP: 'localhost',
  PORT: '5173',
  get BASE_URL() {
    return `http://${this.IP}:${this.PORT}`;
  }
};

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const GENERATE_AD_URL = import.meta.env.VITE_GENERAR_ANUNCIO_URL;
// V3 — usado solo por la generación de la Interfaz V2 (modo Imagen con
// modelo + plantillas). El resto de la app sigue con V2.
export const GENERATE_AD_V3_URL =
  import.meta.env.VITE_GENERAR_ANUNCIO_V3_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_anuncio_v3';
export const GENERATE_VIDEO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_VIDEO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_video_creator';
// Webhook del modo "Video con influencer" (UGC) de la Interfaz V2. Mismo
// payload/flujo que el Director de Estudio pero con su propio workflow en n8n.
export const GENERATE_VIDEO_INFLUENCER_URL =
  import.meta.env.VITE_GENERATE_VIDEO_INFLUENCER_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/video_influencer';
export const GENERATE_AUDIO_CREATOR_URL =
  import.meta.env.VITE_GENERATE_AUDIO_CREATOR_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/generar_audio_creator';
// Endpoints para traducción de video con lip-sync (HeyGen Video Translate v3).
// Async: START dispara el job y devuelve un jobId; STATUS se polea cada N
// segundos hasta que el video traducido esté listo.
export const TRANSLATE_VIDEO_START_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_start';
export const TRANSLATE_VIDEO_STATUS_URL =
  import.meta.env.VITE_TRANSLATE_VIDEO_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/traducir_video_creator_status';
// Endpoints para borrado de objetos en video (Bria video-erase-object via
// Replicate). Async: START dispara el job (n8n corta el clip, llama a Bria por
// chunk, recose y sube el resultado) y devuelve un jobId; STATUS se polea hasta
// que el video borrado esté listo.
export const BRIA_ERASE_START_URL =
  import.meta.env.VITE_BRIA_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_start';
export const BRIA_ERASE_STATUS_URL =
  import.meta.env.VITE_BRIA_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/bria_erase_status';
// SAM2 para el pincel inteligente. `sam2_mask`: frame + marcas → máscara del
// frame (preview, ~síncrono/poll corto). `sam2_propagate`: clip + marcas →
// mask-video propagado a todos los frames (async, encadena con bria_erase).
export const SAM2_MASK_URL =
  import.meta.env.VITE_SAM2_MASK_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_mask';
export const SAM2_ERASE_START_URL =
  import.meta.env.VITE_SAM2_ERASE_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_start';
export const SAM2_ERASE_STATUS_URL =
  import.meta.env.VITE_SAM2_ERASE_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/sam2_erase_status';
// Poses personalizadas (Interfaz V2): el cliente sube una pose → este webhook
// la copia sobre el muñeco default, guarda en `poses_personalizadas` y devuelve
// la pose. Patrón clonado de `procesar_modelo_propio`.
export const PROCESAR_POSE_URL =
  import.meta.env.VITE_PROCESAR_POSE_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/procesar_pose_subida';
// Edición de video con IA (Gemini Omni Flash). Feature NUEVA e independiente
// del editor de Sora (`editar_vid`) — no lo reemplaza. Async en 2 pasos igual
// que traducción/borrado: START dispara el job (crea fila en `omni_edit_jobs`,
// corre Gemini en background y sube el mp4 a `video-project-assets`) y devuelve
// un jobId; STATUS se polea hasta `done`/`error`. Solo clips ≤10s. Ver ADR-500.
export const OMNI_EDIT_START_URL =
  import.meta.env.VITE_OMNI_EDIT_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/omni_edit_start';
export const OMNI_EDIT_STATUS_URL =
  import.meta.env.VITE_OMNI_EDIT_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/omni_edit_status';

// Upscaling de video (Topaz vía Replicate). Async como omni: START crea la
// prediction y devuelve prediction_id; STATUS se polea hasta done (sube el mp4
// a video-project-assets) / error. Ver ADR-596.
export const UPSCALE_VIDEO_START_URL =
  import.meta.env.VITE_UPSCALE_VIDEO_START_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/upscale_video_start';
export const UPSCALE_VIDEO_STATUS_URL =
  import.meta.env.VITE_UPSCALE_VIDEO_STATUS_URL ||
  'https://ai-agency-dt7d.onrender.com/webhook/upscale_video_status';

export const GENERATE_AUTH_TOKEN = import.meta.env.VITE_GENERATE_AUTH_TOKEN;

// ─── Atlas Backend (migración n8n → backend propio) ─────────────────────────
// Base del backend nuevo. Los endpoints migrados se autentican con el JWT de
// la sesión de Supabase (Authorization: Bearer <access_token>) — el backend
// deriva el user_id del token, así que user_id NO viaja en el body. Usar
// `atlasBackendFetch` (lib/atlasBackend.ts), que arma URL + headers solo.
export const ATLAS_BACKEND_URL =
  import.meta.env.VITE_ATLAS_BACKEND_URL ||
  'https://atlas-backend-zhti.onrender.com';
// Rollback fácil: con VITE_USE_ATLAS_BACKEND="false" TODOS los flujos migrados
// vuelven a llamar a los webhooks de n8n como antes. Default: backend nuevo.
// El flag se aplica en el helper de cada flujo (categorizeProduct /
// postGenerateAd), no esparcido por los call sites.
export const USE_ATLAS_BACKEND =
  (import.meta.env.VITE_USE_ATLAS_BACKEND ?? 'true') !== 'false';

// VAPID public key para Web Push (NO es secreta: el navegador la necesita para suscribirse, viaja
// en el bundle igual). DEBE ser el par de VAPID_PRIVATE_KEY del backend (se generan juntas); si
// rota, cambiar en ambos lados. Override por env (VITE_VAPID_PUBLIC_KEY) para staging/rotación.
export const VAPID_PUBLIC_KEY =
  import.meta.env.VITE_VAPID_PUBLIC_KEY ||
  'BDJAN_-undSItjpFcOLQ9xwID0uwugSdCKNJAa81_Kn5btxDv4ZUelhVaDO5VFNbbRs7TzOyyrSmT4xA08ankK4';

// ─── ConfigCat (feature flags / kill-switch de mantenimiento) ──────────────
// El SDK key es PÚBLICO (read-only, seguro para el front, igual que el anon key
// de Supabase). El flag de mantenimiento vive ACÁ y NO en Supabase a propósito:
// la pantalla de mantenimiento es justo lo que querés mostrar cuando Supabase se
// cae, así que el flag debe estar en infra independiente (ConfigCat entrega la
// config por CDN global). Ver ADR-135.
export const CONFIGCAT_SDK_KEY =
  import.meta.env.VITE_CONFIGCAT_SDK_KEY ||
  'configcat-sdk-1/cdveCGkKxEaKQxOGq_FrcA/9vvRoFkQDkqIct65MJelKA';
// Nombre EXACTO del flag booleano creado en el panel de ConfigCat (verificado
// contra el CDN: `maintenanceMode`). Si lo matcheás mal, el SDK devuelve el
// default `false` y el mantenimiento nunca se activa (falla en silencio). Si
// renombrás el flag en el panel, actualizá VITE_CONFIGCAT_MAINTENANCE_KEY.
export const CONFIGCAT_MAINTENANCE_KEY =
  import.meta.env.VITE_CONFIGCAT_MAINTENANCE_KEY || 'maintenanceMode';

// ─── Verificación de celular (anti-abuso del trial) ─────────────────────────
// Gate bloqueante: cuentas creadas DESPUÉS del corte deben verificar un celular
// (único por cuenta, lo garantiza Supabase Auth) antes de usar la app. Las
// anteriores quedan exentas para siempre (grandfathering).
// Ver docs/superpowers/specs/2026-08-31-verificacion-celular-design.md y
// ADR-2026-08-31-verificacion-celular-supabase.
//
// El corte se fija con la fecha/hora REAL del deploy que prende el flag (checklist
// del spec). Hasta entonces queda en el futuro: aunque el flag se prendiera por
// error, ninguna cuenta existente caería en el gate.
export const PHONE_GATE_CUTOFF =
  import.meta.env.VITE_PHONE_GATE_CUTOFF || '2099-01-01T00:00:00Z';
// Flag booleano en ConfigCat (kill-switch del gate; nace en false). Igual que
// maintenanceMode: si el nombre no matchea el del panel, el SDK devuelve false y
// el gate queda apagado en silencio.
export const CONFIGCAT_PHONE_GATE_KEY =
  import.meta.env.VITE_CONFIGCAT_PHONE_GATE_KEY || 'phoneVerificationGate';

// ─── Rebill (suscripciones, Argentina) — checkout embebido ─────────────────
// Gateway de pagos para clientes AR (reemplaza a MercadoPago). Rebill expone un
// web component (`<rebill-checkout>`) que crea el checkout de suscripción desde
// el FRONT usando solo el PUBLIC KEY (seguro para el cliente) + un `plan-id` del
// panel. El backend solo procesa los webhooks (activar plan, cancelar la sub
// vieja). Ver docs/superpowers/specs/2026-07-02-rebill-checkout-integration-design.md
//
// Public key de la organización (seguro para el front).
export const REBILL_PUBLIC_KEY = import.meta.env.VITE_REBILL_PUBLIC_KEY || '';
// Entorno del SDK de Rebill: 'development' | 'staging' | 'production'. El
// carácter sandbox/live lo define el public key; esto solo elige el host de la
// API del SDK. Default: 'production'.
export const REBILL_ENV = (import.meta.env.VITE_REBILL_ENV || 'production') as
  | 'development'
  | 'staging'
  | 'production';
// Mapa plan de Atlas → plan-id (`pln_...`) de Rebill. Cada plan de Atlas necesita
// un plan creado en el panel de Rebill, AL MISMO PRECIO que Atlas (para que el
// precio que muestra la pantalla coincida con el cobro). Completar los env
// `VITE_REBILL_PLAN_*` cuando existan los planes. Si un plan no está mapeado,
// `RebillCardPayment` muestra un error claro en vez de romper.
export const REBILL_PLAN_IDS: Record<string, string> = {
  emprendimiento: import.meta.env.VITE_REBILL_PLAN_EMPRENDIMIENTO || '',
  negocio: import.meta.env.VITE_REBILL_PLAN_NEGOCIO || '',
  enterprise1: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE1 || '',
  enterprise2: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE2 || '',
  enterprise3: import.meta.env.VITE_REBILL_PLAN_ENTERPRISE3 || '',
};
// Base del server de pagos de Atlas. TODO request al payment server debe ir con el
// auth de Atlas (Bearer `GENERATE_AUTH_TOKEN`) → usar `paymentServerFetch`
// (lib/paymentServer.ts), que lo inyecta solo.
export const PAYMENT_SERVER_URL =
  import.meta.env.VITE_PAYMENT_SERVER_URL ||
  'https://atlas-payment-server.onrender.com';
// Endpoint del server de pagos para el cambio de plan one-click de clientes que YA
// están en Rebill (cobra la tarjeta guardada server-side, sin pedir tarjeta ni OTP).
// POST { user_id, plan } → { ok:true, subscriptionId } | { ok:false, error }.
export const REBILL_CHANGE_PLAN_URL =
  import.meta.env.VITE_REBILL_CHANGE_PLAN_URL ||
  `${PAYMENT_SERVER_URL}/rebill/change-plan`;
// Chequeo PREVIO al one-click: ¿el customer de Rebill tiene todo lo que hace falta
// para cobrarle la tarjeta guardada? Rebill exige documento (DNI/CUIT) + teléfono
// para cobrar con `cardId` en AR, y esos datos NO están garantizados: el checkout
// embebido pide el DNI por pago y no lo persiste en el customer.
// POST { user_id } → { ok:true, aplica:false }
//                  | { ok:true, aplica:true, tiene_tarjeta, datos, faltantes[], puede_cobro_directo }.
// Ver ADR-2026-08-07-billing-status-decide-el-one-click.
export const REBILL_BILLING_STATUS_URL =
  import.meta.env.VITE_REBILL_BILLING_STATUS_URL ||
  `${PAYMENT_SERVER_URL}/rebill/billing-status`;
// Gestión de suscripción en el payment server. Los 4 endpoints son
// MULTIPLATAFORMA (el server resuelve MP vs Rebill solo; no ramificar en el front).
// POST /cancel { user_id, motivo?, detalle? } → { ok:true, scheduledFor }.
export const PAYMENT_CANCEL_URL =
  import.meta.env.VITE_PAYMENT_CANCEL_URL || `${PAYMENT_SERVER_URL}/cancel`;
// POST /reactivate { user_id } → { ok:true, nextChargeDate|null }. Deshace una
// cancelación programada vigente (no cobra nada ahora, el ciclo ya estaba pago).
export const PAYMENT_REACTIVATE_URL =
  import.meta.env.VITE_PAYMENT_REACTIVATE_URL ||
  `${PAYMENT_SERVER_URL}/reactivate`;
// POST /pause { user_id, resume_at? } → { ok:true, resumeAt|null }.
export const PAYMENT_PAUSE_URL =
  import.meta.env.VITE_PAYMENT_PAUSE_URL || `${PAYMENT_SERVER_URL}/pause`;
// POST /resume { user_id } → { ok:true }. Rebill cobra al reanudar; MP cobra en
// su próxima fecha de facturación.
export const PAYMENT_RESUME_URL =
  import.meta.env.VITE_PAYMENT_RESUME_URL || `${PAYMENT_SERVER_URL}/resume`;
// Stripe (resto del mundo). Migrados de los webhooks de n8n `stripe-start` y
// `billing-portal` al payment server (ADR-659): mismo body y misma respuesta
// `{ url }`, cambia solo el host. No pegarles con `fetch` pelado → usar
// `fetchStripeCheckoutUrl` / `fetchStripeBillingPortalUrl` (lib/paymentServer.ts),
// que ponen el auth y traducen los errores tipados del server.
// POST /stripe/checkout { user_id, plan, con_descuento?, cupon_id? } → { ok:true, url }.
export const STRIPE_CHECKOUT_URL =
  import.meta.env.VITE_STRIPE_CHECKOUT_URL ||
  `${PAYMENT_SERVER_URL}/stripe/checkout`;
// POST /stripe/billing-portal { user_id } → { ok:true, url }.
export const STRIPE_BILLING_PORTAL_URL =
  import.meta.env.VITE_STRIPE_BILLING_PORTAL_URL ||
  `${PAYMENT_SERVER_URL}/stripe/billing-portal`;
// URL del agente de chat (SSE). Migración chat-agent (edge function) →
// atlas `/v1/agent/chat` (ADR-607): mismo body, mismo stream SSE crudo de
// Anthropic, mismos shapes de error. El flag elige el destino; los clientes
// mantienen su fetch manual (res.body.getReader()) — NADA debe consumir el
// body antes que ellos. El header `apikey` extra que mandan es ignorado por
// el atlas; `id_company` del body también (sale del JWT).
export const AGENT_CHAT_URL = USE_ATLAS_BACKEND
  ? `${ATLAS_BACKEND_URL}/v1/agent/chat`
  : `${SUPABASE_URL}/functions/v1/chat-agent`;

// ─── PostHog (product analytics + session replay + error tracking) ──────────
// La "Project API Key" es PÚBLICA: solo sirve para ESCRIBIR eventos, no para
// leer datos. Va en el bundle del front igual que el anon key de Supabase.
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || '';
// El proyecto vive en la región US (verificado contra /flags/: us→200, eu→401).
// La región se elige al crear el proyecto y NO se puede cambiar después; si
// algún día se migra a EU, esto pasa a https://eu.i.posthog.com.
//
// Este valor es también el punto donde enchufar un reverse proxy el día que
// molesten los adblockers (entre 15% y 30% del tráfico bloquea el dominio de
// PostHog): se apunta a https://app.estudio-atlas.com/ingest y se agrega el
// `location /ingest` en el nginx de Donweb. Sin tocar código.
export const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
// Escotilla para probar la integración desde localhost. Por defecto NO se
// trackea nada fuera de producción, así los embudos no se ensucian con la
// navegación del dev (ver src/lib/posthog.ts).
export const POSTHOG_DEBUG = import.meta.env.VITE_POSTHOG_DEBUG === 'true';

// ─── URL pública de la app ──────────────────────────────────────────────────
// Adónde apuntan los links que el usuario COMPARTE (hoy: el de referidos). No
// se usa `window.location.origin` a propósito: quien comparte puede estar en un
// preview de Vercel, en localhost o detrás de un dominio viejo, y el link que
// le mande a un amigo tiene que llevar siempre al Atlas de verdad.
export const APP_PUBLIC_URL =
  import.meta.env.VITE_APP_PUBLIC_URL || 'https://app.estudio-atlas.com';
